module.exports = __webpack_public_path__ + "static/index/img/baikal-804.54a86d65.jpg";